<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de paises</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="Pais.cpaId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="Pais.cpaNome"
                                        label="Nome" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="Pais.cpaNomeFormal"
                                        label="Nome Formal" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="Pais.cpaSigla"
                                        label="Sigla" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="Pais.cpaSigla3"
                                        label="Sigla 3" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="Pais.cpaFone"
                                        label="Fone" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select v-model="Pais.cpaVisivel" label="Visível" :items="StatusVisivel"
                                        item-title="nome" item-value="cpaVisivel" variant="underlined">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="Pais.cpaId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="preprocessData(Paises)" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-cpaVisivel="item">
                            <span>{{ item.cpaVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-cpaFone="item">
                            <span>{{ item.cpaFone === "" || item.cpaFone === null ? '' : item.cpaFone }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroPaisView',
    components: {
        EasyDataTable
    },
    data: () => ({
        Pais: {
            cpaId: 0,
            cpaNome: '',
            cpaSigla: '',
            cpaVisivel: '',
            cpaSigla3: '',
            cpaFone: '',
            cpaNomeFormal: '',
        },
        Paises: [],
        StatusVisivel: [{ nome: "Sim", cpaVisivel: true }, { nome: "Não", cpaVisivel: false }],
        headers: [
            { text: "Id", value: "cpaId", sortable: true, },
            { text: "Nome", value: "cpaNome", sortable: true, },
            { text: "Nome Formal", value: "cpaNomeFormal", sortable: true, },
            { text: "Sigla", value: "cpaSigla", sortable: true, },
            { text: "Sigla 3", value: "cpaSigla3", sortable: true, },
            { text: "Visivel", value: "cpaVisivel", sortable: true, },
            { text: "Fone", value: "cpaFone" },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
            };
            });
        },
        Limpar() {
            this.Pais.cpaId = 0;
            this.Pais.cpaNome = '';
            this.Pais.cpaSigla = '';
            this.Pais.cpaVisivel = '';
            this.Pais.cpaSigla3 = '';
            this.Pais.cpaFone = '';
            this.Pais.cpaNomeFormal = '';
            this.Get();
        },
        Add() {
            if (this.Pais.cpaNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Pais.cpaSigla == ''){
                this.$mensagemAviso("Sigla Obrigatória.")
            }
            else {
                if (this.Pais.cpaVisivel === "" || this.Pais.cpaVisivel === null){
                    this.Pais.cpaVisivel = true;
                }
                if (this.Pais.cpaFone === "" || this.Pais.cpaFone === null){
                    this.Pais.cpaFone = null;
                }
                else{
                    this.Pais.cpaFone = this.Pais.cpaFone.toString();
                }
                axios.post(`/Process/CadPaises/Add`, this.Pais)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.Pais.cpaNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Pais.cpaSigla == ''){
                this.$mensagemAviso("Sigla Obrigatória.")
            }
            else {
                if (this.Pais.cpaVisivel === "" || this.Pais.cpaVisivel === null){
                    this.Pais.cpaVisivel = true;
                }
                if (this.Pais.cpaFone === "" || this.Pais.cpaFone === null){
                    this.Pais.cpaFone = null;
                }
                else{
                    this.Pais.cpaFone = this.Pais.cpaFone.toString();
                }
                
                axios.put(`/Process/CadPaises/Update`, this.Pais)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.Pais = item;
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.cpaId;
                axios.delete(`/Process/CadPaises/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            axios.get(`/Process/CadPaises/GetAll`)
                .then(response => {
                    this.Paises = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
